import axios from '../../../utils/interceptor'
import { BASE_URL, GET_DOCUMENTS, CREATE_DOCUMENTS, EDIT_DOCUMENTS } from '../../../resources/APIEndpoints'

function MediaServices(){
    this.getDocument = (body) => axios.post(BASE_URL + GET_DOCUMENTS, body)
    this.addDocument = (body) => axios.post(BASE_URL + CREATE_DOCUMENTS, body)
    this.editDocument = (body) => axios.post(BASE_URL + EDIT_DOCUMENTS, body)
}

export default new MediaServices();